'use strict';

angular.module('randomization')
    .controller('RandomizationLogController', ['ShareCrfSDK', 'ShareCrfApiErrorCodes', 'ShareCrfApiOdataParser', 'CrdConfigurationService', 'TableItems', 'AccountManager', function(ShareCrfSDK, ShareCrfApiErrorCodes, ShareCrfApiOdataParser, CrdConfigurationService, TableItems, AccountManager) {
        var vm = this;

        /**
         * Bindings
         * - vm.sitesAvailable
         */
        vm.entityLabel = CrdConfigurationService.getLabelSingular();

        vm.ready = false;
        vm.loading = false;

        vm.error = false;
        vm.success = false;

        vm.items = [];
        vm.totalItems = 0;
        vm.limit = TableItems.getSelectedOption('randomization');
        vm.orderBy = 'id';
        vm.orderReverse = true;
        vm.currentPage = 0;

        vm.readUnblind = false;
        vm.readBlocks = false;

        vm.filters = {};

        function buildQueryParameters(controller) {
            var parameters = {};

            // Query filters
            var filters = buildQueryFilters(controller.filters);

            // Query expand record
            parameters.expand = buildQueryExpand(controller);

            if (filters.length) {
                parameters.filters = filters.join(' and ');
            }

            // Pagination
            parameters.limit = controller.limit;
            parameters.offset = controller.limit * controller.currentPage; // controller.currentPage is zero-based

            // Order
            parameters.order = 'id desc';

            if (controller.orderBy) {
                parameters.order = controller.orderBy + ' ' + (controller.orderReverse ? 'desc' : 'asc');
            }

            return parameters;
        }

        function buildQueryFilters(formFilters) {
            var filters = [];

            if (formFilters.site) {
                var code = ShareCrfApiOdataParser.cleanStringValue(formFilters.site);
                filters.push('recordData/site/code eq ' + code);
            }

            return filters;
        }

        function buildQueryExpand(controller) {
            var expand = 'record($select=id,uid,deletedAt)';

            if (controller.readUnblind) {
                expand += ',revelations($select=createdAt,userData;$orderby=createdAt desc)';
            }

            return expand;
        }

        vm.$onInit = function() {
            vm.ready = true;

            // Iniciar manejador de sesión antes de resolver permisos
            AccountManager.init().then(function() {
                // Si se pueden ver las revelaciones de ciego
                vm.readUnblind = AccountManager.hasPermission('read unblind records');

                // Si se puede consultar el estado de los bloques
                // GARU-3637 Aparece la columna de bloques si el usuario tiene permiso, aunque la aleatorización sea simple
                vm.readBlocks = AccountManager.hasPermission('read randomization blocks');

                // Listar datos
                return vm.load();
            });
        };

        vm.load = function() {
            vm.loading = true;
            vm.error = false;

            var parameters = buildQueryParameters(vm);

            return ShareCrfSDK.randomization.log(parameters)
                .then(function(response) {
                    vm.items = response.rows;
                    vm.totalItems = response.total;
                    vm.error = false;
                })
                .catch(function(error) {
                    vm.items = [];
                    vm.totalItems = 0;
                    vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                })
                .finally(function() {
                    vm.loading = false;
                });
        };
    }]);
